import React from "react";
import {Col, Row, Card, CardBody, CardTitle} from "reactstrap";
import Settings from "../settings";
import PaymentInfoCards from "./PaymentinfoCards";

export default function LandingPage() {
    return <>
        <Row className="mb-5">
            <Col>
                <h2>Payment Management</h2>
                <p className="lead">Manage payments including lot management, project management, and transactions listing.</p>
            </Col>
        </Row>
        
        <Row>
            <Col>
                <PaymentInfoCards/>
            </Col>
        </Row>

        <Row>
            <Col>
                <Settings/>
            </Col>
        </Row>
    </>;
}